import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "col-span-6" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import ToggleSwitch from '@/components/inputs/ToggleSwitch.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';

import { ref, watch, onMounted } from 'vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import BlockedDate from '@/classes/BlockedDate';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditFormSection',
  props: {
    branchId: {
        type: String,
        default: null
    },
    blockedDateId: {
        type: String,
        default: null
    }
},
  setup(__props) {

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)

const selectedDate = ref(null)
const isWholeDay = ref(null)

const props = __props;

const payload = ref({
    branch_id: props.branchId,
    is_wholeday: true,
    date: null,
    reason: null,
    start_time: null,
    end_time: null,
});

const updateBlockedDate = () => {
    loader.value = true;

    BlockedDate.updateBlockedDate(props.blockedDateId, payload.value)
        .then((result: any) => {
            loader.value      = false;
            showSuccess.value = true;
            payload.value = result.data.blockedDate;

            setTimeout(() => {
                window.location.replace(`/branches/${props.branchId}/blocked-dates`)
            }, 2000);
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const editBlockedDate = () => {
    loader.value = true;

    BlockedDate.editBlockedDate(props.blockedDateId)
        .then((result: any) => {
            loader.value = false;
            payload.value = result.data.blockedDate;
            selectedDate.value = payload.value.date;
            isWholeDay.value = payload.value.is_wholeday == 1 ? true : false;
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

watch(
    () => selectedDate.value,
    (val) => {
        if(val)
            payload.value.date = new Date(selectedDate.value).toISOString().split('T')[0];
    },
    { immediate: true }
);

watch(
    () => isWholeDay.value,
    (val) => {
        if(val) {
            payload.value.start_time = null;
            payload.value.end_time = null;
        }
        payload.value.is_wholeday = val;
    },
    { immediate: true }
);

onMounted(() => {
    editBlockedDate();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FormSection, null, {
      title: _withCtx(() => [...(_cache[12] || (_cache[12] = [
        _createTextVNode(" Blocked Date Information ", -1)
      ]))]),
      description: _withCtx(() => [...(_cache[13] || (_cache[13] = [
        _createTextVNode(" Relevant data and other details ", -1)
      ]))]),
      form: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(ToggleSwitch, {
            key: isWholeDay.value,
            value: isWholeDay.value,
            onChange: _cache[0] || (_cache[0] = 
                (value) =>
                    (isWholeDay.value = value)
                ),
            label: "Whole Day"
          }, null, 8, ["value"]))
        ]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(DatePicker, {
            key: selectedDate.value,
            modelValue: selectedDate.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDate).value = $event)),
            id: "selectedDate",
            name: "selectedDate",
            label: "Date",
            placeholder: "MM/DD/YYYY"
          }, null, 8, ["modelValue"]))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TextInput, {
            modelValue: payload.value.reason,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.reason) = $event)),
            id: "reason",
            name: "reason",
            label: "Reason",
            placeholder: "Reason"
          }, null, 8, ["modelValue"])
        ]),
        (!isWholeDay.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(TextInput, {
                  type: "time",
                  modelValue: payload.value.start_time,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.start_time) = $event)),
                  id: "start_time",
                  name: "start_time",
                  label: "Start Time",
                  placeholder: "Start Time",
                  step: 60,
                  helper: "Do not include minutes"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(TextInput, {
                  type: "time",
                  modelValue: payload.value.end_time,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.end_time) = $event)),
                  id: "end_time",
                  name: "end_time",
                  label: "End Time",
                  placeholder: "End Time",
                  step: 60,
                  helper: "Do not include minutes"
                }, null, 8, ["modelValue"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      actions: _withCtx(() => [
        _createVNode(ButtonComponent, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (showConfirmation.value = true))
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode(" Submit ", -1)
          ]))]),
          _: 1
        }),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: showError.value,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false)),
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showError.value = false)),
      errors: errors.value
    }, {
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(errorMsg.value), 1)
      ]),
      _: 1
    }, 8, ["show", "errors"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onCancel: _cache[8] || (_cache[8] = ($event: any) => (showSuccess.value = false)),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (showSuccess.value = false)),
      "action-text": "Confirm",
      title: "Blocked Date Updated!",
      content: "Blocked Date has been updated successfully"
    }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      show: showConfirmation.value,
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[11] || (_cache[11] = ($event: any) => {showConfirmation.value = false; updateBlockedDate() }),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Submit Blocked Date?",
      content: "Are you sure you wish to submit this blocked date?"
    }, null, 8, ["show"])
  ], 64))
}
}

})